export default __webpack_public_path__ + "static/media/Logo-md.caeeef7e.svg";